module.exports = __webpack_public_path__ + "img/logo.f3ea9160.png";